import { render, staticRenderFns } from "./Preference.vue?vue&type=template&id=19cc2259&scoped=true"
import script from "./Preference.vue?vue&type=script&lang=js"
export * from "./Preference.vue?vue&type=script&lang=js"
import style0 from "./Preference.vue?vue&type=style&index=0&id=19cc2259&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19cc2259",
  null
  
)

export default component.exports